import React from "react";
import { useTranslation } from "react-i18next";
import { ElementRoot } from "./ElementRoot.jsx";
import { mediaElementShape } from "./shapes/index.jsx";
import AngLoader from "../../component.ang_loader.jsx";

export const AudioPreviewMessage = () => {
  const { t } = useTranslation();
  return (
    <ElementRoot loaded>
      <div className="ang_preview_message_wrapper">
        <div className="ang_preview_message_wrapper_inner">
          <div className="ang_preview_image ang_preview_image_audio" />
          <div className="ang_preview_message">
            <p>{t("Preview of this audio is beeing generated.")}</p>
            <p>{t("Audio will automatically play as soon it is done.")}</p>
            <AngLoader />
          </div>
        </div>
      </div>
    </ElementRoot>
  );
};

AudioPreviewMessage.propTypes = mediaElementShape;
